import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import ProjectsPage from '../pages/projects/page';
import Gallery from '../pages/gallery/page';
import News from '../pages/news/page';
import ContactPage from '../pages/contact/page';
import TestimonialsPage from '../pages/testimonials/page';
import LogosAdmin from '../pages/admin/logos/page';
import AdminStatsPage from "../pages/admin/stats/page";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/gallery',
    element: <Gallery />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/admin/logos',
    element: <LogosAdmin />,
  },
  {
    path: "/admin/stats",
    element: <AdminStatsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
